import { fetchCustomerDetails, signOut, triggerUserPilot } from './Routes.commands';
import {
    getCustomerId,
    getCustomerToken,
    getPermissionsDetermined,
    isAuthenticated,
    isCustomerSelected,
} from '../authentication/state/Auth.selectors';
import { getDocumentTitle, isLoading } from '../common/state/ui/UI.selectors';

import Component from './Routes.component';
import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
        asyncLoading: isLoading(state),
        customerId: getCustomerId(state),
        customerToken: getCustomerToken(state),
        documentTitle: getDocumentTitle(state),
        isAuthenticated: isAuthenticated(state),
        isCustomerSelected: isCustomerSelected(state),
        permissionsDetermined: getPermissionsDetermined(state),
    };
};

const mapDispatchToProps = {
    fetchCustomerDetails,
    signOut,
    triggerUserPilot,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
